export const particleConfig = {
  particles: {
    color: {
      value: "#dbdbdb",
    },
    links: {
      color: "#dbdbdb",
      distance: 150,
      enable: true,
      opacity: 1,
      width: 1,
    },
    move: {
      direction: "none",
      enable: true,
      outModes: {
        default: "bounce",
      },
      random: false,
      speed: 1,
      straight: false,
    },
    number: {
      density: {
        enable: true,
      },
      value: 70,
    },
    opacity: {
      value: 1,
    },
    shape: {
      type: "circle",
    },
    size: {
      value: { min: 2, max: 4 },
    },
  },
  detectRetina: true,
};
